import { AgGridReact } from "@ag-grid-community/react";
import { AllModules } from "@ag-grid-enterprise/all-modules";
import useStore from "../../../../store";
import { observer } from "mobx-react";
import { Button, } from "antd";
import { vsmCommon } from "../../../../config/messages";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faClipboardList, faExchangeAlt } from "@fortawesome/free-solid-svg-icons";
import { default_roles } from "../../../../utils/GlobalFunction";
import TimeFilter, { FloatingTimeFilter } from "../../../../component/TimeFilter";
import ServerGridConfig from "../../../../config/ServerGridConfig";
// import TimeFilter, { FloatingTimeFilter } from "../../../../component/timeFilter";


const ActionRenderer = observer((props) => {
	const { AUTH } = useStore();
	const { openViewModal, openRecordModal, openChangeSCAndLocationModal } = props.agGridReact.props.frameworkComponents;

	return (
		<div className="action-column">
			{AUTH.checkPrivileges("#3101#") && (
				<Button
					type="text"
					className="viewIcon mr-15"
					title="View"
					size="large"
					style={{ padding: 7 }}
					onClick={() => {
						openViewModal(props.data);
					}}
				>
					<FontAwesomeIcon icon={faEye} />
				</Button>
			)}
			{AUTH.checkPrivileges("#3120#") && (
				<Button
					type="text"
					className="recordIcon mr-15"
					size="large"
					title="Record"
					style={{ padding: 7 }}
					onClick={() => {
						openRecordModal(props.data);
					}}
				>
					<FontAwesomeIcon icon={faClipboardList} />
				</Button>
			)}
			{(AUTH.checkPrivileges("#3126#") || AUTH.checkPrivileges("#3091#")) && [default_roles.admin, default_roles.mis_executive,].includes(AUTH?.user?.role_id) && (
				<Button
					type="text"
					className="resignIcon"
					size="large"
					title="Change Location & Sales Consultant"
					style={{ padding: 7 }}
					onClick={() => {
						openChangeSCAndLocationModal(props.data);
					}}
				>
					<FontAwesomeIcon icon={faExchangeAlt} />
				</Button>
			)}
		</div>
	);
});

const ListComponent = observer((props) => {
	const { openViewModal, openRecordModal, openChangeSCAndLocationModal } = props;
	const {
		ActiveInquiriesStore: { setupGrid },
	} = useStore();

	const gridOptions = {
		columnDefs: [
			{
				headerName: "# ID",
				field: "id",
				filter: "agNumberColumnFilter",
				pinned: "left",
				minWidth: 120,
				width: 120,
			},
			{
				headerName: "Code",
				field: "code",
			},
			{
				headerName: "Mfg Code",
				field: "mfg_code",
			},
			{
				headerName: "Opened On",
				field: "date",
				filter: 'agDateColumnFilter',
				filterParams: {
					buttons: ['reset'],
					inRangeInclusive: true,
					suppressAndOrCondition: true,
				},
			},
			{
				headerName: "Time",
				field: "time_in_changed",
				filter: "timeFilter",
			},
			{
				headerName: "Customer",
				field: "full_name",

			},
			{
				headerName: "Brand",
				field: "brand.name",
			},
			{
				headerName: "Model",
				field: "model.name",
			},
			{
				headerName: "Variant",
				field: "variant.name",
			},
			{
				headerName: "Consultant",
				field: "sales_consultant.name",
			},
			{
				headerName: "Reporting To",
				field: "sales_consultant.reporting_to.name",
				valueGetter: (params) =>
					params.data && params.data.sc_id === null ? "N/A" : params.data?.sales_consultant?.reporting_to.name,
			},
			{
				headerName: "Location",
				field: "location.name",
			},
			{
				headerName: "Area",
				field: "area.name",
			},
			{
				headerName: "Mode",
				field: "inquiry_mode.name",
			},
			{
				headerName: "Media",
				field: "inquiry_media.name",
			},
			{
				headerName: "Media Sub Category",
				field: "inquiry_media_sub_category.name",
			},
			{
				headerName: "Test Drive",
				field: "test_drive",
				filter: false,
			},
			{
				headerName: "Customer Type",
				field: "customer_type.name",
			},
			{
				headerName: "Exchange",
				field: "exchange",
				filter: false,
			},
			{
				headerName: "Resale",
				field: "resale",
				filter: false,
			},
			{
				headerName: "Finance",
				field: "finance",
				filter: false,
			},
			{
				headerName: "Ratings",
				field: "rating.name",
			},
			{
				headerName: "Receptionist",
				field: "receptionist.name",
				filter: false,
			},
			{
				headerName: "Days Opened",
				field: "days_opened",
				filter: "agNumberColumnFilter",
			},
			{
				headerName: "Actions",
				field: "actions",
				type: "actionColumn",
				filter: false,
				sortable: false,
				pinned: "right",
				minWidth: 180,
				width: 180,
			},
		],
	};
	return (
		// <div className="ag-theme-alpine grid_wrapper">
		// 	<AgGridReact
		// 		rowHeight={LocalGridConfig.rowHeight}
		// 		headerHeight={LocalGridConfig.headerHeight}
		// 		rowData={list_data}
		// 		modules={AllModules}
		// 		columnDefs={gridOptions.columnDefs}
		// 		defaultColDef={LocalGridConfig.defaultColDef}
		// 		columnTypes={LocalGridConfig.columnTypes}
		// 		overlayNoRowsTemplate={vsmCommon.noRecord}
		// 		frameworkComponents={{ ActionRenderer, timeFilter: TimeFilter, floatingTimeFilter: FloatingTimeFilter, openViewModal, openRecordModal, openChangeSCAndLocationModal }}
		// 		onGridReady={setupGrid}
		// 		gridOptions={LocalGridConfig.options}
		// 		components={LocalGridConfig.components}
		// 		onFilterChanged={onFilterChanged}
		// 		onSortChanged={onFilterChanged}
		// 	/>
		// </div>
		<div className="ag-theme-alpine grid_wrapper">
			<AgGridReact
				rowHeight={ServerGridConfig.rowHeight}
				headerHeight={ServerGridConfig.headerHeight}
				modules={AllModules}
				columnDefs={gridOptions.columnDefs}
				defaultColDef={ServerGridConfig.defaultColDef}
				columnTypes={ServerGridConfig.columnTypes}
				overlayNoRowsTemplate={vsmCommon.noRecord}
				frameworkComponents={{ ActionRenderer, timeFilter: TimeFilter, floatingTimeFilter: FloatingTimeFilter, openViewModal, openRecordModal, openChangeSCAndLocationModal }}
				onGridReady={setupGrid}
				gridOptions={ServerGridConfig.options}
			/>
		</div>
	);
});

export default ListComponent;
